/* Progressive enhancement for the curated look. No pricing or cart mutations. */
(function () {
  'use strict';
  function revealLookJump(event) {
    var detail = event.detail || {};
    var target = detail.target && document.getElementById(detail.target);
    if (!target || target.hidden) return;
    document.querySelectorAll('.stmn-look-jump').forEach(function (link) {
      link.hidden = false;
      link.setAttribute('href', '#' + detail.target);
    });
  }
  document.addEventListener('stmn:look-ready', revealLookJump);
  document.addEventListener('stmn:look-offer-state', function (event) {
    var detail = event.detail || {};
    if (detail.target !== 'stmn-complete-look') return;
    var percentage = Number(detail.percentage);
    var visible = detail.eligible === true && percentage > 0 && percentage <= 100;
    var lang = String(document.documentElement.lang || 'it').slice(0, 2);
    var previewLabel = lang === 'en' ? 'Preview' : lang === 'fr' ? 'Aperçu' : lang === 'de' ? 'Vorschau' : lang === 'es' ? 'Vista previa' : lang === 'pt' ? 'Pré-visualização' : 'Anteprima';
    document.querySelectorAll('[data-stmn-jump-offer]').forEach(function (badge) {
      badge.hidden = !visible;
      badge.textContent = visible ? (detail.preview ? previewLabel + ' ' : '') + '−' + percentage + '%' : '';
    });
  });

  // The link opens the component's own PDP in a new tab. Kiwi therefore resolves
  // that product's existing chart, never the main product's chart by accident.
  function openOwnSizeGuide() {
    if (window.location.hash !== '#stmn-size-guide') return;
    var observer, timer, opened = false;
    function stop() { if (observer) observer.disconnect(); window.clearTimeout(timer); }
    function open() {
      var trigger = document.querySelector('.ks-chart-modal-link.sizing-chart-modal-link');
      if (!trigger || !trigger.getClientRects().length || opened) return false;
      opened = true;
      stop();
      trigger.scrollIntoView({ block: 'center' });
      trigger.focus({ preventScroll: true });
      trigger.click();
      return true;
    }
    if (open()) return;
    observer = new MutationObserver(open);
    observer.observe(document.body, { childList: true, subtree: true });
    timer = window.setTimeout(function () {
      stop();
      // If the installed chart is unavailable, leave the correct product page
      // usable, with an honest explanation rather than a substituted chart.
      var anchor = document.getElementById('kiwi-sizing-anchor');
      if (!anchor || opened) return;
      var note = document.createElement('p');
      note.setAttribute('role', 'status');
      note.tabIndex = -1;
      note.style.cssText = 'font-size:14px;line-height:1.5;padding:12px 0';
      var lang = document.documentElement.lang.slice(0, 2);
      note.textContent = lang === 'en' ? 'The size guide could not load. Please reload this product page to try again.' : lang === 'fr' ? 'Le guide des tailles n’a pas pu être chargé. Rechargez la page de ce produit pour réessayer.' : lang === 'de' ? 'Die Größentabelle konnte nicht geladen werden. Lade die Produktseite neu, um es erneut zu versuchen.' : lang === 'es' ? 'No se ha podido cargar la guía de tallas. Vuelve a cargar la página de este producto para intentarlo de nuevo.' : lang === 'pt' ? 'Não foi possível carregar o guia de tamanhos. Recarrega a página deste produto para tentar novamente.' : 'La guida taglie non è stata caricata. Ricarica la pagina di questo capo per riprovare.';
      anchor.appendChild(note);
      note.focus();
    }, 15000);
    window.addEventListener('pagehide', stop, { once: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', openOwnSizeGuide, { once: true });
  else openOwnSizeGuide();
})();
